// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__J0co7","content":"style_content__A6pve","amount":"style_amount__gC3g6","rechargeScaleAndMove":"style_rechargeScaleAndMove__dTQzD"};